import { render, staticRenderFns } from "./AddressUnit.vue?vue&type=template&id=4b8419e0&scoped=true&"
import script from "./AddressUnit.vue?vue&type=script&lang=js&"
export * from "./AddressUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8419e0",
  null
  
)

export default component.exports